import { render, staticRenderFns } from "./Progress.vue?vue&type=template&id=23bb9a46&scoped=true&"
import script from "./Progress.vue?vue&type=script&lang=js&"
export * from "./Progress.vue?vue&type=script&lang=js&"
import style0 from "./Progress.vue?vue&type=style&index=0&id=23bb9a46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bb9a46",
  null
  
)

export default component.exports